import React from 'react';

const Icon = ({ name, size = '', className = '', ...props }) => {
  // Bootstrap Icons mapping
  const iconMap = {
    // Navigation
    dashboard: 'bi-grid-3x3-gap',

    // People & Companies
    users: 'bi-people',
    user: 'bi-person',
    building: 'bi-building',
    addressBook: 'bi-person-lines-fill',

    // Asset Management
    cube: 'bi-box',
    collection: 'bi-collection',

    // Operations
    clipboard: 'bi-clipboard-data',
    truck: 'bi-truck',

    // Financial
    calculator: 'bi-calculator',
    currencyDollar: 'bi-currency-pound',

    // Actions
    plus: 'bi-plus-lg',
    edit: 'bi-pencil-square',
    pencil: 'bi-pencil',
    trash: 'bi-trash',
    download: 'bi-download',
    upload: 'bi-upload',
    search: 'bi-search',
    eye: 'bi-eye',
    save: 'bi-save',
    info: 'bi-info-circle',

    // Communication
    slack: 'bi-slack',
    mail: 'bi-envelope',
    phone: 'bi-telephone',
    paperPlane: 'bi-send',
    userPlus: 'bi-person-plus',
    informationCircle: 'bi-info-circle',

    // Theme
    sun: 'bi-sun',
    moon: 'bi-moon',

    // Status
    check: 'bi-check-lg',
    checkCircle: 'bi-check-circle',
    x: 'bi-x-lg',
    alert: 'bi-exclamation-triangle',
    exclamationTriangle: 'bi-exclamation-triangle',
    clipboardCheck: 'bi-clipboard-check',
    shieldCheck: 'bi-shield-check',

    // Navigation arrows
    chevronLeft: 'bi-chevron-left',
    chevronRight: 'bi-chevron-right',

    // Settings
    cog: 'bi-gear',

    // Import/Export
    documentText: 'bi-file-text',

    // Tree/Overview
    sitemap: 'bi-diagram-3',
    link: 'bi-link-45deg',
    bell: 'bi-bell',
    expand: 'bi-arrows-expand',
    collapse: 'bi-arrows-collapse',
    tag: 'bi-tag',
    cart: 'bi-cart',
    wrench: 'bi-wrench',
    stack: 'bi-stack',
    document: 'bi-file-earmark',
    refresh: 'bi-arrow-clockwise',
  };

  const bootstrapIcon = iconMap[name] || `bi-${name}`;
  const sizeClass = size ? `fs-${size}` : '';

  return <i className={`bi ${bootstrapIcon} ${sizeClass} ${className}`} {...props} />;
};

export default Icon;
